webpackJsonp([148408532507482],{

/***/ 700:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"contentfulNovica":{"id":"c2tr7Nv7etK4AuEasW84e04","naslov":"Slovensko Državno Veteransko Prvenstvo","createdAt":"2018-06-16T09:39:18.520Z","slika":{"file":{"url":"//images.ctfassets.net/0mpr9vmqs1v8/4F7gXzbt96UIs2IEkkcyCq/2a6acde1ca1b68be046f3245a1945d38/34305331_1295174050614000_5682180026812858368_n.jpg"},"description":"Novica - Slovensko Drzavno Veteransko Prvenstvo"},"tekst":{"tekst":"🏆 __Samo Rubin__ ➡️ državni prvak 45+  🙌\n🥈🥈 __Marko Kroflič__ - 2. mesto 35+ med posamezniki in 2. mesto v dvojicah s __Tadej Šeme__\n🥉 🥉 __Kim Mezga__ - 3. mesto 35+ med posameznicami in v mix-u\n🥉 __Šefik Mašič__ - 3. mesto 35+ med posamezniki\n\nČestitke!!! 🙌🙌"}}}}

/***/ })

});


// WEBPACK FOOTER //
// path---novice-c-2-tr-7-nv-7-et-k-4-au-eas-w-84-e-04-d73c160f162b2ed44a99.js